export default __webpack_public_path__ + "static/media/boat.d127dfb1.svg";